import request from '@/router/axios';

export const getDashboardData = (data) => {
  return request({
    url: '/api/produce/alarm-analysis/dashboard',
    method: 'post',
    data
  });
};

